import { render, staticRenderFns } from "./CreateFormShop.vue?vue&type=template&id=2f7a0e48"
import script from "./CreateFormShop.vue?vue&type=script&lang=js"
export * from "./CreateFormShop.vue?vue&type=script&lang=js"
import style0 from "./CreateFormShop.vue?vue&type=style&index=0&id=2f7a0e48&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports